import template from './template.html'
import controller from './webskedPitches.controller'

export default {
  restrict: 'E',
  template,
  bindings: {
    storyObj: '<',
  },
  controller,
  controllerAs: 'vm',
}
